/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react'
import { ReactReduxContext } from 'react-redux'
import { Button } from 'reactstrap'
import intl from 'react-intl-universal'
import { Circulation, Story } from '~/types'
import { websitesToCirculationDataConverter } from '../CirculateTab/CirculateTab.utils'
import { SelectorModal } from './SelectorModal'

import './SiteSelectorV2.scss'
import { Website } from './Website'
import denormalizer from '../../story/util/denormalizer'

interface SiteSelectorV2Props {
  onCirculationsChange: (selectedCirculations: Circulation[]) => Promise<void>
  isTemplate?: boolean
}

export const SiteSelectorV2: React.FC<SiteSelectorV2Props> = ({
  onCirculationsChange,
  isTemplate = false,
}) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const [sortedCirculations, setSortedCirculations] = useState<Circulation[]>(
    []
  )

  const { store } = React.useContext(ReactReduxContext)
  const { storyData } = store.getState()
  const {
    circulations,
    story,
  }: { circulations: Circulation[]; story: Story } = storyData

  const websitesCount = circulations.length

  let sectionsCount = 0
  circulations.forEach((circulation) => {
    if (circulation.website_sections) {
      sectionsCount += circulation.website_sections.length
    }
  })

  function handleToggle(value) {
    setIsOpen(value)
  }

  function handleOnMssData(selectedCirculationData) {
    const selectedCirculations = websitesToCirculationDataConverter(
      selectedCirculationData,
      storyData.story._id
    )

    selectedCirculations.forEach((selectedCirculation) => {
      delete selectedCirculation.website_primary_section?.referent.provider

      if (selectedCirculation.website_sections) {
        selectedCirculation.website_sections.forEach((section) => {
          delete section.referent.provider
        })
      }
    })

    handleToggle(false)
    onCirculationsChange(selectedCirculations)

    const stickyTooltip = document.getElementsByClassName('tooltip')[0]
    if (stickyTooltip) {
      document.getElementsByClassName('tooltip')[0].remove()
    }
  }

  function getSortedCirculations(websites: Circulation[]): void {
    const primaryWebsite = websites.filter((circulation) => {
      return circulation.website_id === story.canonical_website
    })

    const secondaryWebsites = websites.filter((circulation) => {
      return circulation.website_id !== story.canonical_website
    })

    const sortedWebsites = [...primaryWebsite, ...secondaryWebsites]
    setSortedCirculations(sortedWebsites)
  }

  React.useEffect(() => {
    async function initWebsites() {
      const denormalizedWebsites = await denormalizer(circulations)
      getSortedCirculations(denormalizedWebsites)
    }

    initWebsites()
  }, [circulations, story.canonical_website])

  return (
    <>
      <section className="site-selector-v2" data-testid="site-selector-v2">
        <div
          className="site-selector-v2--panel-hdr"
          data-testid="site-selector-v2--panel-hdr"
        >
          <div className="site-selector-v2--panel-hdr--left">
            {intl.get('SiteSelector.title', {
              websitesCount,
              sectionsCount,
            })}
          </div>
          <div className="site-selector-v2--panel-hdr--right">
            <Button onClick={() => handleToggle(true)}>
              {intl.get('SiteSelector.button')}
            </Button>
          </div>
        </div>
        <div
          className="site-selector-v2--panel-websites"
          data-testid="site-selector-v2--panel-websites"
        >
          {sortedCirculations.map((circulation: Circulation, index) => {
            return (
              <Website
                isPrimary={circulation.website_id === story.canonical_website}
                circulation={circulation}
                key={index}
              />
            )
          })}
        </div>
      </section>
      <SelectorModal
        isOpen={isOpen}
        toggle={handleToggle}
        handleOnMssData={handleOnMssData}
        isTemplate={isTemplate}
      />
    </>
  )
}
